import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { CheckLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { isAccessModalVar } from "../../../graphql/globalVar/state";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

import { FEATURE_KEYS } from "./contsants";
import access_img from "./img/access-img.webp";

function AccessModal() {
  const { t } = useTranslation();
  const show = useReactiveVar(isAccessModalVar);
  const locale = useGetUrlLocale();

  return (
    <Modal
      show={show}
      onHide={() => isAccessModalVar(false)}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3 pb-0"></Modal.Header>
      <Modal.Body className="text-center text-muted p-3">
        <img
          className="img-fluid mb-3 access-modal-img"
          src={access_img}
          alt="access img"
        />
        <h4 className="fs-4 text-dark fw-bold mb-3">
          {t("events.modals.checkpointAccess.title")}
        </h4>
        <p className="fs-6 text-dark mb-3 px-2 px-md-3">
          {t("events.modals.checkpointAccess.description")}
        </p>
        <ul className="d-grid gap-2 p-0 m-0">
          {FEATURE_KEYS.map((key) => (
            <li
              key={key}
              className="d-flex align-items-center justify-content-center gap-2 fs-6"
            >
              <CheckLg className="text-success" />
              <span className="text-dark">{t(key)}</span>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col xs={12}>
            <Link
              to={`${locale}/payment`}
              className="btn btn-success w-100 py-2 py-md-3 rounded-3 fw-bold text-white text-decoration-none"
              onClick={() => isAccessModalVar(false)}
            >
              {t("events.modals.checkpointAccess.upgradePro")}
            </Link>
          </Col>
          <Col xs={12}>
            <p
              className="py-2 rounded-3 text-center text-info text-decoration-underline m-0 cursor-pointer"
              onClick={() => isAccessModalVar(false)}
            >
              {t("events.modals.checkpointAccess.maybeLater")}
            </p>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default AccessModal;
